import React, { useEffect, useState } from "react";

import IconSearchNotFound from "../../../assets/icons/icons8-search-notfound.png";

import * as S from './styles.js';
import { theme } from "../../../styles/theme.js";
import { TaglineP } from "../../../styles/stylesTypography.js";

export const USER = "@userinfo";
export const VAL = "@validade";

const ViewMap = ({ coordenadas }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasCoordinates, setHasCoordinates] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            const coordsExist = coordenadas?.latitude && coordenadas?.longitude;
            setHasCoordinates(coordsExist);
            setIsLoading(false);
        }, 500);
        
        return () => clearTimeout(timer);
    }, [coordenadas]);

    if (isLoading) {
        return (
            <S.Container>
                <S.ContainerContent>
                    <S.Loading/>
                </S.ContainerContent>
            </S.Container>
        );
    }

    if (!hasCoordinates) {
        return (
            <S.Container>
                <S.ContainerContent>
                    <img src={IconSearchNotFound} alt="Ícone de pesquisa" />

                    <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
                        Fazenda sem coordenadas cadastradas
                    </TaglineP>
                </S.ContainerContent>
            </S.Container>
        );
    }

    return (
        <S.Container>
            <S.Map
                src={`https://www.meteoblue.com/en/weather/maps/widget/${coordenadas.latitude}N${coordenadas.longitude}E654_America%2FSao_Paulo?windAnimation=1&gust=1&satellite=1&cloudsAndPrecipitation=1&temperature=1&sunshine=1&extremeForecastIndex=1&geoloc=fixed&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=10&autowidth=auto`}
                frameBorder="0"
                scrolling="no"
                allowTransparency
                sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
                title="Mapa meteorológico da fazenda"
            />
        </S.Container>
    );
};

export default ViewMap;